import { useContext } from 'react'
import InfoListLayoutContext from '../InfoListLayout/InfoListLayout.context'
import { Wrapper } from './InfoListSeparator.styled'

const InfoListSeparator: React.FC = ({ children }) => {
  const { labelWidth } = useContext(InfoListLayoutContext)

  return (
    <Wrapper width={labelWidth} data-test='InfoListSeparator'>
      {children}
    </Wrapper>
  )
}

export default InfoListSeparator
